import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

const T = Translator.create();
let _apiClient: ApiClient;
const _logger = Log.create('Video-Service');

export class VideoService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestAddVideoActivityAsync(params: any) {
        let requestUrl = 'api/video/add';

        if(params.activityId) {
            requestUrl = 'api/video/update';
        }
        
        return _apiClient.RequestAsync('POST', requestUrl, params).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestAddOrUpdateQuestionVideoAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/video/questionadorupdate', params).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestGetVideoAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/activity/activitylist', params)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

}

